/**
 * "Trust, privacy & compliance" documentation section (ADR-0074).
 *
 * A docs-level map over Syncanix's trust posture — data residency and isolation,
 * how data is handled and retained, your privacy rights, the compliance program,
 * and AI transparency. It explains and links out to the deeper Trust Center
 * surface (/trust/*) and the existing Core-concepts pages rather than restating
 * legal text, and it mirrors the live status verbs from the trust content
 * (compliance-status.json / subprocessors.json) so nothing is overclaimed.
 */
import { TRUST_AI_PAGE } from './pages/trust-ai.page';
import { TRUST_COMPLIANCE_PAGE } from './pages/trust-compliance.page';
import { TRUST_DATA_PAGE } from './pages/trust-data.page';
import { TRUST_OVERVIEW_PAGE } from './pages/trust-overview.page';
import { TRUST_PRIVACY_PAGE } from './pages/trust-privacy.page';
import { TRUST_RESIDENCY_PAGE } from './pages/trust-residency.page';
import { TRUST_SECURITY_PAGE } from './pages/trust-security.page';

import type { DocSection } from './types';

export const TRUST_SECTION: DocSection = {
  id: 'trust',
  titleKey: 'docs.section.trust.title',
  pages: [
    TRUST_OVERVIEW_PAGE,
    TRUST_SECURITY_PAGE,
    TRUST_RESIDENCY_PAGE,
    TRUST_DATA_PAGE,
    TRUST_PRIVACY_PAGE,
    TRUST_COMPLIANCE_PAGE,
    TRUST_AI_PAGE,
  ],
};
